export {
  ForgotEmail,
  ForgotPassword,
  CreateAccountPage,
  CreateAccountFormPage,
  ResetPassword
} from '../Login'
export {
  BOTMyAppointmentsDetails,
  BOTAccessYourAppointmentInfo,
  BOTNoAccountMessage
} from '../MyAppointments'
